import request from "@/utils/httpRequest.js"

 export function event(data) {
  return request({
    url: 'page/event',
    method: 'post',
    data
  })
}
